import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=1d502179&scoped=true&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=1d502179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d502179",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d502179')) {
      api.createRecord('1d502179', component.options)
    } else {
      api.reload('1d502179', component.options)
    }
    module.hot.accept("./ProductTab.vue?vue&type=template&id=1d502179&scoped=true&", function () {
      api.rerender('1d502179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/ProductTab.vue"
export default component.exports